import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Logo } from '@hub-la/design-system';
import { AccountDropdownProvider, AccountDropdown } from '@hub-la/fe-account-dropdown';
import { useContainer } from '@hub-la/fe-container';
import { useRoleplay, useGetRoleplayReference } from '@hub-la/fe-roleplay';
import { useHistory } from 'react-router-dom';
import useCurrentUser from '../hooks/use-current-user.js';
import { getSiteHost } from '../utils/routes.js';

const UserNavigation = () => {
  var _a, _b, _c, _d, _e;
  const {
    isRoleplay
  } = useRoleplay();
  const currentUser = useCurrentUser();
  const history = useHistory();
  const container = useContainer();
  const {
    data: roleplayUser
  } = useGetRoleplayReference({
    enabled: isRoleplay
  });
  return currentUser ? jsxs(AccountDropdownProvider, Object.assign({
    container: container,
    inverted: true
  }, {
    children: [currentUser && !isRoleplay && jsx(AccountDropdown, {
      push: history.push,
      id: (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) !== null && _a !== void 0 ? _a : '',
      firstName: (_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.firstName) !== null && _b !== void 0 ? _b : '',
      picture: (_c = currentUser === null || currentUser === void 0 ? void 0 : currentUser.picture) !== null && _c !== void 0 ? _c : null,
      username: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
      bankAccount: 3
    }), currentUser && isRoleplay && roleplayUser && jsx(AccountDropdown, {
      push: history.push,
      id: roleplayUser.userId,
      firstName: (_d = roleplayUser.name) !== null && _d !== void 0 ? _d : undefined,
      picture: (_e = roleplayUser.picture) !== null && _e !== void 0 ? _e : null,
      username: roleplayUser.username,
      bankAccount: 3
    })]
  })) : jsx("a", Object.assign({
    href: getSiteHost()
  }, {
    children: jsx("div", Object.assign({
      style: {
        cursor: 'pointer'
      }
    }, {
      children: jsx(Logo, {
        hierarchy: "primary",
        size: "small"
      })
    }))
  }));
};

export { UserNavigation as default };
